export { default as withDynamicTag } from './withDynamicTag';
export { default as isReactComponent } from './isReactComponent';
export { default as withUniqueId } from './withUniqueId';
export { default as generateUniqueId } from './generateUniqueId';
export { default as getAllPropCasesForColors } from './getAllPropCasesForColors';